/**
 * The complete list of languages supported by the translation system.
 * This is the single source of truth — add new languages here and in the
 * corresponding locales/*.json dictionary file.
 */
export const SUPPORTED_LANGS = ['en', 'es', 'fr'] as const
export type SupportedLang = (typeof SUPPORTED_LANGS)[number]

/** Human-readable display labels for each supported language (native name). */
export const LANGUAGE_LABELS: Record<SupportedLang, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français'
}

/** English names for each supported language (used in "View in X" labels when UI is in English). */
export const LANGUAGE_ENGLISH_NAMES: Record<SupportedLang, string> = {
  en: 'English',
  es: 'Spanish',
  fr: 'French'
}

/**
 * "View in X" labels written in each language's own script.
 * Used in the language switcher so the label is always readable
 * by a speaker of that language, regardless of the current UI lang.
 */
export const VIEW_IN_LABELS: Record<SupportedLang, string> = {
  en: 'View in English',
  es: 'Ver en español',
  fr: 'Voir en français'
}
